export const SpaceList = [
  {
    id: '中国',
    label: '中国',
    isSelect: false,
    type: '国家',
    spaceLevel: 'spaceL0',
    highLight: '默认服务',
    scaneName: '默认服务',
    num: 567896,
    objType: 'space',
    components: '',
    level: '1',
    children: [
      {
        id: '北京数据中心',
        label: '北京数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: '北京',
        scaneName: '北京',
        highLight: '北京',
        num: 105486,
        objType: 'space',
        components: 'ShuJuZhongXingSheng',
        level: '2',
        children: [
          {
            id: '分数据中心-01',
            label: '分数据中心-01',
            isSelect: false,
            type: '园区',
            spaceLevel: '园区',
            scaneName: '园区',
            highLight: '园区',
            num: 89524,
            objType: 'space',
            components: 'ShuJuZhongXingYuanQu',
            level: '3',
            children: [
              {
                id: 'SM_IDC机房楼',
                label: 'IDC机房楼',
                isSelect: false,
                type: '建筑',
                spaceLevel: '',
                scaneName: '园区',
                num: 35524,
                objType: 'space',
                components: 'JianZhu',
                level: '4',
                children: [
                  {
                    id: 'SM_IDC室内04',
                    label: 'F3',
                    isSelect: false,
                    type: '楼层',
                    spaceLevel: '楼层',
                    scaneName: '园区',
                    highLight: '楼层',
                    num: 15623,
                    objType: 'space',
                    components: 'LouCeng',
                    level: '5',
                    children: [
                      {
                        id: '机柜组机房',
                        label: '机柜组机房',
                        isSelect: false,
                        type: '房间',
                        spaceLevel: '房间',
                        highLight: '机柜组机房',
                        scaneName: '园区',
                        num: 5649,
                        objType: 'space',
                        components: 'FangJian',
                        level: '6',
                        children: [
                          {
                            id: 'C03-004_SM_机柜组',
                            label: 'C03-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 96,
                            objType: 'space',
                            components: 'JiGuiZaixian',
                            level: '7',
                            children: [
                              {
                                id: 'C03-004-04_SM_设备机柜',
                                label: 'C03-004-04_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: 'C03-004-04_SM_设备机柜',
                                num: 7,
                                objType: 'space',
                                components: 'JiGuiLixian',
                                level: '8',
                                children: [
                                  {
                                    id: 'C03-004-04_SM_配线架',
                                    label: 'C03-004_配线架',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'JiQi',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_交换机',
                                    label: 'C03-004_交换机',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'JiaoHuanJi',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_数据服务器_虚拟机',
                                    label: 'C03-004_数据服务器_虚拟机',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'FuWuQiXuNiJi',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_路由器',
                                    label: 'C03-004_路由器',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'LuYouQi',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_服务器',
                                    label: 'C03-004_服务器',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'FuWuQiBiaoZhun',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_网络存储服务器',
                                    label: 'C03-004_网络存储服务器',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'JiQi',
                                    level: '9',
                                  },
                                  {
                                    id: 'C03-004-04_SM_GPU服务器',
                                    label: 'C03-004_GPU服务器',
                                    isSelect: false,
                                    type: '设备',
                                    spaceLevel: '设备',
                                    scaneName: '园区',
                                    highLight: '设备',
                                    num: 0,
                                    objType: 'space',
                                    components: 'JiQi',
                                    level: '9',
                                  },
                                ],
                              },
                              {
                                id: 'C03-004-02_SM_设备机柜',
                                label: 'C03-004-02_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-03_SM_设备机柜',
                                label: 'C03-004-03_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-05_SM_设备机柜',
                                label: 'C03-004-05_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-06_SM_设备机柜',
                                label: 'C03-004-06_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-07_SM_设备机柜',
                                label: 'C03-004-07_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-08_SM_设备机柜',
                                label: 'C03-004-08_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              },
                              {
                                id: 'C03-004-09_SM_设备机柜',
                                label: 'C03-004-09_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                highLight: '',
                                num: 7,
                                objType: 'space',
                                components: '',
                                level: '8',
                                children: []
                              }
                            ],
                          },
                          {
                            id: 'A01-004_SM_机柜组',
                            label: 'A01-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 89,
                            objType: 'space',
                            components: 'JiGuiZaixian',
                            level: '7',
                            children: [
                              {
                                id: 'A01-04_SM_设备机柜',
                                label: 'A01-04_SM_设备机柜',
                                highLight: 'A01-004-04_SM_机柜组',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                num: 6,
                                objType: 'space',
                                components: 'JiGuiLixian',
                                level: '8',
                                children: [],
                              },
                            ],
                          },
                          {
                            id: 'F06-004_SM_机柜组',
                            label: 'F06-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: 'JiGuiZaixian',
                            level: '7',
                            children: [
                              {
                                id: 'F06-004-07_SM_设备机柜',
                                label: 'F06-004-07_SM_设备机柜',
                                highLight: 'F06-004-07_SM_设备机柜',
                                isSelect: false,
                                type: '机柜',
                                spaceLevel: 'spaceL7',
                                scaneName: '园区',
                                num: 4,
                                objType: 'space',
                                components: 'JiGuiZaixian',
                                level: '8',
                                children: [],
                              },
                            ],
                          },
                          {
                            id: 'A01-003_SM_机柜组',
                            label: 'A01-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 65,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'A01-001_SM_机柜组',
                            label: 'A01-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'B02-001_SM_机柜组',
                            label: 'B02-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'B02-002_SM_机柜组',
                            label: 'B02-002_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 55,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'C03-001_SM_机柜组',
                            label: 'C03-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 65,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'C03-002_SM_机柜组',
                            label: 'C03-002_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 64,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'A01-002_SM_机柜组',
                            label: 'A01-002_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'B02-003_SM_机柜组',
                            label: 'B02-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 65,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'C03-003_SM_机柜组',
                            label: 'C03-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 65,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'B02-004_SM_机柜组',
                            label: 'B02-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 64,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'D04-001_SM_机柜组',
                            label: 'D04-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'D04-003_SM_机柜组',
                            label: 'D04-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 32,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'D04-004_SM_机柜组',
                            label: 'D04-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 54,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'E05-001_SM_机柜组',
                            label: 'E05-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'E05-002_SM_机柜组',
                            label: 'E05-002_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 54,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'E05-003_SM_机柜组',
                            label: 'E05-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'E05-004_SM_机柜组',
                            label: 'E05-004_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 65,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'F06-001_SM_机柜组',
                            label: 'F06-001_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 34,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'F06-002_SM_机柜组',
                            label: 'F06-002_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 54,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                          {
                            id: 'F06-003_SM_机柜组',
                            label: 'F06-003_SM_机柜组',
                            isSelect: false,
                            type: '机柜组',
                            highLight: '机柜组',
                            spaceLevel: '机柜',
                            scaneName: '园区',
                            num: 87,
                            objType: 'space',
                            components: '',
                            level: '7',
                            children: [],
                          },
                        ],
                      },
                      {
                        id: '电池组机房',
                        label: '电池组机房',
                        isSelect: false,
                        type: '房间',
                        spaceLevel: '房间',
                        scaneName: '园区',
                        highLight: '电池组机房',
                        num: 5798,
                        objType: 'space',
                        components: '',
                        level: '6',
                        children: [],
                      },
                      {
                        id: 'UPS设备机房',
                        label: 'UPS设备机房',
                        isSelect: false,
                        type: '房间',
                        spaceLevel: '房间',
                        scaneName: '园区',
                        highLight: 'UPS设备机房',
                        num: 4176,
                        objType: 'space',
                        components: '',
                        level: '6',
                        children: [],
                      },
                    ],
                  },
                  {
                    id: 'SM_IDC室内03',
                    label: 'F2',
                    isSelect: false,
                    type: '楼层',
                    spaceLevel: '楼层',
                    scaneName: '园区',
                    num: 14523,
                    objType: 'space',
                    components: '',
                    level: '5',
                    children: [],
                  },
                  {
                    id: 'SM_IDC室内02',
                    label: 'F1',
                    isSelect: false,
                    type: '楼层',
                    spaceLevel: '楼层',
                    scaneName: '园区',
                    num: 59378,
                    objType: 'space',
                    components: '',
                    level: '5',
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            id: '分数据中心-02',
            label: '分数据中心-02',
            isSelect: false,
            type: '园区',
            spaceLevel: '园区',
            scaneName: '园区',
            num: 15962,
            objType: 'space',
            components: '',
            level: '3',
            children: [],
          },
        ],
      },
      {
        id: '上海数据中心',
        label: '上海数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: 'spaceL1',
        scaneName: '',
        num: 98642,
        objType: 'space',
        components: '',
        level: '2',
        children: [],
      },
      {
        id: '西安数据中心',
        label: '西安数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: 'spaceL1',
        scaneName: '',
        num: 55647,
        objType: 'space',
        components: '',
        level: '2',
        children: [],
      },
      {
        id: '深圳数据中心',
        label: '深圳数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: 'spaceL1',
        scaneName: '',
        num: 89562,
        objType: 'space',
        components: '',
        level: '2',
        children: [],
      },
      {
        id: '云南数据中心',
        label: '云南数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: 'spaceL1',
        scaneName: '',
        num: 23654,
        objType: 'space',
        components: '',
        level: '2',
        children: [],
      },
      {
        id: '郑州数据中心',
        label: '郑州数据中心',
        isSelect: false,
        type: '省市',
        spaceLevel: 'spaceL1',
        scaneName: '',
        num: 45896,
        objType: 'space',
        components: '',
        level: '2',
        children: [],
      },
    ],
  },
]

import ObjectManager from './ObjectManager.vue'
export default ObjectManager
